import { render, staticRenderFns } from "./LowstkL.vue?vue&type=template&id=039cef5a"
import script from "./LowstkL.vue?vue&type=script&lang=js"
export * from "./LowstkL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports